export const GooglePayRoutes = {
    ROOT: "/googlepay",
    PERSONAL_DATA: "/googlepay/personal-data",
    SUMMARY: "/googlepay/summary",
    SIGNING: "/googlepay/signing",
    SUCCESS: "/googlepay/success",
    PDF: "/googlepay/pdf",
};



// WEBPACK FOOTER //
// ./src/components/googlePay/GooglePayRoutes.ts